import type { ChecklistOption } from '../components/checklist';
import { DropdownTriggerButton, FilterDropdown } from '../components/dropdown';
import { createFilter } from '../create-filter';
import { type FilterProps } from '../types';
import { arrayFilterMethods, getSingleValueLabel } from '../utils';
import { ChecklistControl } from './checklist-control';

export type DropdownChecklistControlProps<T = string> = FilterProps<
  T[],
  {
    label: string;
    options: ChecklistOption<T>[];
    triggerWithBackground?: boolean;
  }
>;

export const DropdownChecklistControl = createFilter(
  function UnboundDropdownChecklistControl({
    filter,
    label,
    options,
    triggerWithBackground
  }: DropdownChecklistControlProps) {
    const { resetSelectedValues, appliedSize, isApplied, isSelected } =
      arrayFilterMethods(filter);

    return (
      <FilterDropdown
        trigger={
          <DropdownTriggerButton
            selected={isApplied}
            badge={appliedSize > 1 ? appliedSize : undefined}
            withBackground={triggerWithBackground}
          >
            {getSingleValueLabel(filter.appliedValue, options, label)}
          </DropdownTriggerButton>
        }
        displayClearButton={isSelected}
        onClearRequest={resetSelectedValues}
        maxWidth={300}
        maxHeight={320}
      >
        <ChecklistControl filter={filter} options={options} />
      </FilterDropdown>
    );
  }
);
